import { connect } from 'react-redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'

import NewBookingFormRowHeader from '../../components/NewBookingFormRowHeader'

interface NewBookingFormRowHeaderPropsInterface {
  isTOFlight: boolean
}

export const mapStateToProps = (
  _state: ReduxStoreInterface,
  props: NewBookingFormRowHeaderPropsInterface
) => ({
  showTravelClass: props.isTOFlight,
  showLuggage: !props.isTOFlight,
})

export default connect(mapStateToProps)(NewBookingFormRowHeader)
